import { render, staticRenderFns } from "./detail-sd.vue?vue&type=template&id=1b3e2542&scoped=true&"
import script from "./detail-sd.vue?vue&type=script&lang=js&"
export * from "./detail-sd.vue?vue&type=script&lang=js&"
import style0 from "./detail-sd.vue?vue&type=style&index=0&id=1b3e2542&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3e2542",
  null
  
)

export default component.exports